const localeValues = {
  ko: {
    emptyText: "\uAC80\uC0C9 \uACB0\uACFC\uAC00 \uC5C6\uC5B4\uC694.",
    itemCount: (count) => `\uCD1D ${count}\uAC1C \uC120\uD0DD`,
    clear: "\uCD08\uAE30\uD654"
  },
  en: {
    emptyText: "No search results.",
    itemCount: (count) => `${count} items selected`,
    clear: "clear"
  }
};

export { localeValues };
//# sourceMappingURL=localeValues.mjs.map
